import { Box, Divider } from '@mui/material'

const AppDivider = () => {
    return (
        <Box width="100%" sx={{ mt: 1 }}>
            <Divider sx={{ mb: 1 }} />
        </Box>
    )
}

export default AppDivider
